/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const AlignHorizontalSpaceAround = [
  "svg",
  defaultAttributes,
  [
    ["rect", { width: "6", height: "10", x: "9", y: "7", rx: "2" }],
    ["path", { d: "M4 22V2" }],
    ["path", { d: "M20 22V2" }]
  ]
];

export { AlignHorizontalSpaceAround as default };
//# sourceMappingURL=align-horizontal-space-around.js.map
